import * as React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import Button from "@mui/material/Button"

const OuterWrapper = styled.div.attrs({
    className: "atlasWidth",
})`
    width: 100%;
    *zoom: 1;
    margin-right: auto;
    margin-left: auto;
    padding-top: 3rem;

    @media screen and (min-width: 60em) {
        padding-top: 2rem;
    }
`

const Header = styled.h1`
    font-size: 1.25rem;
    margin: 0;
    margin-top: 0.25rem;
    font-family: Exo, sans-serif;
    background: linear-gradient(
        182deg,
        rgba(255, 255, 255, 0) 53%,
        rgba(237, 106, 90, 0.5) 50%
    );
    width: auto;
    display: table;

    @media screen and (min-width: 60em) {
        font-size: 2.25rem;
        text-align: left;
    }
`

const SubHeader = styled.h1`
    font-size: 1rem;
    margin-top: 0.5rem;
    color: #838383;
    font-family: HeadlandOne, sans-serif;
    font-weight: normal;

    @media screen and (min-width: 60em) {
        text-align: left;
    }

    @media screen and (min-width: 30em) {
        margin-bottom: 2rem;
    }
`

const Title = (props) => {
    return (
        <OuterWrapper>
            <div style={{ marginBottom: "1rem" }}>
                <Link to="/entry-list">
                    <Button variant="outlined" style={{ marginBottom: "1rem" }}>
                        Back to all entries
                    </Button>
                </Link>
            </div>
            <Header>{props.title}</Header>
            <SubHeader>{props.subtitle}</SubHeader>
        </OuterWrapper>
    )
}

export default Title
